export default function CTASection() {
  return (
    <section className="bg-[#1A3A2E] py-32 px-6">
      <div className="max-w-[1000px] mx-auto text-center">
        <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
          Comienza Tu Formación Profesional Hoy
        </h2>
        <p className="text-xl text-[#D4D4D4] mb-12">
          Acceso inmediato a los 8 módulos + material descargable + certificación
        </p>
        <button className="px-16 py-5 bg-[#39FF14] text-black text-xl font-bold rounded-xl hover:bg-[#32E010] hover:scale-105 transition-all whitespace-nowrap cursor-pointer">
          Inscribirme Ahora
        </button>
        <p className="text-[15px] text-gray-400 mt-5">
          Garantía de satisfacción 30 días
        </p>
      </div>
    </section>
  );
}
